module.exports = __webpack_public_path__ + "img/route-johannesburg.d03cfc0c.webp";